import { format } from "date-fns";
import { formatAsMoney } from "./utils/format-as-money";
import { connect } from "react-redux";
import { setSingleTransaction } from "./redux/careBalanceActions";
import { withRouter } from "react-router-dom";
const caretRight = "/img/care-balance/caret-right.svg";

function SingleCareHistory({ transaction, history, dispatch }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      data-testid={`single-transaction-${transaction?.id}`}
    >
      <div>
        <p
          style={{
            fontWeight: 500,
            fontSize: "1.4rem",
            lineHeight: "2.4rem",
            letterSpacing: "0%",
            color: "#1C1B1B",
          }}
        >
          {transaction?.narration}
        </p>

        <p
          style={{
            fontWeight: 700,
            fontSize: "1.4rem",
            lineHeight: "2.2rem",
            letterSpacing: "0%",
            color:
              transaction?.transactionType === "FUND_WALLET"
                ? "#288D68"
                : "#4F4F4F",
          }}
        >
          {formatAsMoney({ value: +transaction?.amount })}
        </p>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <p
          style={{
            fontSize: "1.4rem",
            lineHeight: "1.6rem",
            letterSpacing: "0%",
            color: "#4F4F4F",
          }}
        >
          {format(new Date(transaction.date), "MMMM d, yyyy, h:mm aa")}
        </p>

        <button
          onClick={() => {
            dispatch(setSingleTransaction(transaction));

            history.push("/care-history-detail");
          }}
        >
          <img src={caretRight} alt="Caret Right" style={{ width: "24px" }} />
        </button>
      </div>
    </div>
  );
}

export default withRouter(connect()(SingleCareHistory));
